
import React from 'react';
import PropTypes from 'prop-types';

import restrictNumber from '../../../../utils/restrictNumber';
import {
  StyledOptionField,
  StyledOptionSliderSlot,
  StyledSpacedOptionFields,
} from '../../../../components/common/AnnotationOptions/AnnotationOptions.styled';
import Slider from '../../../../components/common/Slider';

const MIN_VALUE = 0;
const MAX_VALUE = 4;
const SLIDER_STEP = 0.2;
const POPUP_SLIDER_WIDTH = '100%';

const LineHeightField = ({
  annotation: text,
  updateAnnotation: updateText,
  t,
}) => {
  const { lineHeight } = text;

  const lineHeightValue =
    lineHeight === undefined || lineHeight === null ? MIN_VALUE : lineHeight;

  return (
    <StyledSpacedOptionFields className="respark_annotation-option-panel respark_text-spacing-option-panel">
      <StyledOptionField>
        <StyledOptionSliderSlot>
          <Slider
            width={POPUP_SLIDER_WIDTH}
            annotation=" px"
            onChange={(val) =>
              updateText({
                lineHeight: restrictNumber(val, MIN_VALUE, MAX_VALUE),
              })
            }
            value={lineHeightValue}
            step={SLIDER_STEP}
            min={MIN_VALUE}
            max={MAX_VALUE}
          />
        </StyledOptionSliderSlot>
      </StyledOptionField>
    </StyledSpacedOptionFields>
  );
};

LineHeightField.propTypes = {
  annotation: PropTypes.instanceOf(Object).isRequired,
  updateAnnotation: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default LineHeightField;
